import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIsElectronicTradingOffer } from 'shared/hooks/useIsElectronicTradingOffer';
import { selectIsOfferPublished, selectOffer, selectUser } from 'shared/selectors';
import { selectIsChatsNewSendMessageFromObjectCardGroupCExperimentEnabled } from 'shared/selectors/abExperiments';
import { offerChatSelector } from 'shared/selectors/offerChat';
import { getHintQuestions } from 'shared/services/chats/getHintQuestions';

import { CallUnderDescriptionBannerContainer } from './CallUnderDescriptionBannerContainer';
import { HintQuestionsContainer } from './HintQuestionsContainer';
import { HintQuestionsContainerRedesigned } from './HintQuestionsContainerRedesigned';

export function CallUnderDescriptionContainer() {
  const { isChatsEnabled, hintQuestions } = useSelector(offerChatSelector);
  const offer = useSelector(selectOffer);
  const user = useSelector(selectUser);
  const isOfferPublished = useSelector(selectIsOfferPublished);

  const isElectronicTradingOffer = useIsElectronicTradingOffer();

  const isGroupCChatExperimentEnabled = useSelector(selectIsChatsNewSendMessageFromObjectCardGroupCExperimentEnabled);
  const isOfferRent = offer.dealType === 'rent';
  const isExperimentEnabled = isGroupCChatExperimentEnabled && isOfferRent;

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getHintQuestions());
  }, []);

  if (!isOfferPublished || user?.cianUserId === offer.cianUserId || isElectronicTradingOffer) {
    return null;
  }

  if (isChatsEnabled && hintQuestions.length && !isExperimentEnabled) {
    return <HintQuestionsContainer />;
  }

  if (isChatsEnabled && hintQuestions.length && isExperimentEnabled) {
    return <HintQuestionsContainerRedesigned />;
  }

  return <CallUnderDescriptionBannerContainer isRedesignedBlock={isExperimentEnabled} />;
}
